import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { Badge } from "react-bootstrap";

const CardItem = ({ item, index, selectTab }) => {
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	return (
		<tr key={index} className="text-center">
			<td className="text-wrap-mode">{item.username}</td>
			<td>{item.phone}</td>
			<td>{item.email}</td>
			{selectTab === "staff" && (
				<td className="text-wrap-mode">
					{!!item?.admin_permissions?.length
						? item?.admin_permissions[0]?.admin_role?.name
						: "-"}
				</td>
			)}
			<td>{item.license_number}</td>
			<td className="text-wrap-mode d-flex gap-8">
				{selectTab === "staff" ? (
					!!item?.admin_zones?.length ? (
						item?.admin_zones?.map((res) => {
							return (
								<Badge variant={`warning light`}>
									{lang === "en" ? res.zone?.name_en : res.zone?.name_ar || "-"}
								</Badge>
							);
						})
					) : (
						"-"
					)
				) : (
					<Badge variant={`warning light`}>
						{lang === "en" ? item.zone?.name_en : item.zone?.name_ar || "-"}
					</Badge>
				)}
			</td>
			<td className="text-wrap-mode">{item.work_shift?.name}</td>
			<td className="text-wrap-mode text-center">
				<a href={item?.license_image} target="_blanck">
					<i
						className="las la-image fs-28"
						style={{
							width: "28px",
							height: "28px",
						}}
					/>
				</a>
			</td>
			{/* <td className="text-wrap-mode">{item?.civil_id || "-"}</td> */}
			{selectTab === "staff" && (
				<td>
					<Badge variant={`${!item?.isBlocked ? "success" : "danger"} light`}>
						{!item?.isBlocked
							? Translate[lang].active
							: Translate[lang].deactive}
					</Badge>
				</td>
			)}
		</tr>
	);
};
export default CardItem;
